module.exports = __webpack_public_path__ + "img/sport_PREMIER.6384172f.png";